import { render, staticRenderFns } from "./news2.vue?vue&type=template&id=e8e27478&scoped=true"
import script from "./news2.vue?vue&type=script&lang=js"
export * from "./news2.vue?vue&type=script&lang=js"
import style0 from "./news2.vue?vue&type=style&index=0&id=e8e27478&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8e27478",
  null
  
)

export default component.exports